import React from "react";

const FiltresTerrain = ({ annonces, filters, onChange }) => {
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newFilters = { ...filters };

    if (type === "checkbox") {
      newFilters[name] = checked
        ? [...(filters[name] || []), value]
        : filters[name].filter((v) => v !== value);
    } else {
      newFilters[name] = value;
    }

    onChange(newFilters);
  };

  const uniqueLocalisations = [...new Set(annonces.map((a) => a.localisation).filter(Boolean))];

  return (
    <div>
      <h3>Localisation</h3>
      {uniqueLocalisations.map((loc) => (
        <label key={loc}>
          <input
            type="checkbox"
            name="localisation"
            value={loc}
            onChange={handleChange}
          />
          {loc}
        </label>
      ))}

      <h3>Superficie (m²)</h3>
      <input type="number" name="superficieMin" placeholder="Min" onChange={handleChange} />
      <input type="number" name="superficieMax" placeholder="Max" onChange={handleChange} />

      <h3>Prix</h3>
      <input type="number" name="prixMin" placeholder="Min" onChange={handleChange} />
      <input type="number" name="prixMax" placeholder="Max" onChange={handleChange} />
    </div>
  );
};

export default FiltresTerrain;
